<template>
    <v-checkbox
        ref="checkbox"
        v-bind="$attrs"
        :input-value="inputValue"
        :color="color"
        :disabled="disabled"
        v-on="$listeners"
    >
        <template v-for="(value, name) in $slots" v-slot:[name]>
            <template v-if="name == 'label'">
                <span :key="name" :class="[{ 'text--primary': !disabled }, 'text-caption']">
                    <slot :name="name" />
                </span>
            </template>
            <template v-else>
                <slot :name="name" />
            </template>
        </template>
    </v-checkbox>
</template>

<script lang="ts">
import { Vue, Component, Prop, Model } from 'vue-property-decorator';

@Component({
    name: 'Checkbox',
    inheritAttrs: false,
})
export default class Checkbox extends Vue {
    @Prop({ default: 'accent' }) readonly color: string;
    @Prop({ default: false }) readonly disabled: boolean;
    @Model('change') readonly inputValue: boolean;

    reset(): void {
        (this as any).$refs['checkbox'].reset();
    }
}
</script>
